export default {
  tags: [
    {
      value: 3,
      label: '芯片标签'
    },
    {
      value: 2,
      label: '涂层标签'
    },
    {
      value: 4,
      label: '普通标签'
    },
    {
      value: 1,
      label: '定制标签'
    },
    {
      value: 5,
      label: '一品一码标签'
    }
  ]
}
